<script setup lang="ts">
import TheChecklistPage from "shared-ui/pages/TheChecklistPage.vue";

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    headerTitleKey: "the_checklist_page.title",
  },
});
</script>

<template>
  <TheChecklistPage />
</template>

<style scoped lang="css"></style>
